import { render, staticRenderFns } from "./pattern-suggestions-header.vue?vue&type=template&id=f732d198&"
import script from "./pattern-suggestions-header.vue?vue&type=script&lang=js&"
export * from "./pattern-suggestions-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports